export const ageGroup = {
  'all': '全て',
  'ten': '10代',
  'twenty': '20代',
  'thirty': '30代',
  'forty': '40代',
  'fifty': '50代',
  'sixty': '60代',
  'seventy': '70代',
  'eighty': '80代',
  'ninety': '90代',
};

export const sendTimeType = {
  'soon': '今すぐ',
  'date': '指定した日時から',
}
